//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { LocalizationHelper } from '../../helpers/localization-helper'

import { Enums } from '../../models/common/enums'
import { OpReport } from '../../models/dw/op-report'
import { SESSION } from '../../models/custom/session'

export class ReportHelper {
            
    // Consts

    public static get FILE_NAME_PREFIX(): string { return 'reports' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType  { return Enums.ReferenceType.IdReport }  
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName  { return Enums.SimaxModuleName.Report }

    // Consts End


    // Methods

    public static deleteReport(dataProvider: DataProvider, idReport: number, moduleName: Enums.SimaxModuleName): JQueryPromise<void>  {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()
        const toDelete: OpReport = new OpReport(null)

        toDelete.idReport = idReport

        dataProvider.Report
            .deleteReport(toDelete)
            .then(() => {
                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, moduleName))

                deferred.resolve()
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                    CommonHelper.openInfoPopup(errorMsg, 'error', 4000)
                } else {
                    CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETE_ERROR, moduleName), 'error', 4000)
                }

                deferred.reject()
            })

        return deferred.promise()
    }

    public static saveReport(dataProvider: DataProvider, report: OpReport): JQueryPromise<OpReport> {
        const deferred: JQueryDeferred<OpReport> = $.Deferred<OpReport>()

        dataProvider.Report
            .saveReport(report)
            .then((savedObject: OpReport) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }
    
    // Methods End
}